import React from 'react';

export const ResourceCanvas: React.FC = () => {
    return (
        <div>
            Resource ...
        </div>
    );
};

